import { parseParam, getLang } from '../utils/index'

const langInfo = getLang()

function getTeamsList(url) {
    // https://wolvesesports.com/wp-json/wolves/v1/players?team=fifa,fifa-online4,identity5,rocket-league,call-of-duty-mobile,wolves-gr-esports&lang=en
    return fetch(url +'&lang='+ langInfo.lang)
        .then(function(response) {
            return response.json()
        })
}

function getTeams() {
    return fetch('/wp-json/wolves/v1/teams?lang='+langInfo.lang)
    .then(function(response) {
        return response.json()
    })
}

function getScheduleNavList() {
    return fetch('/wp-json/wolves/v1/schedule_categories')
        .then(function(response) {
            return response.json()
        })
}

function getScheduleList(data) {
    data.lang = langInfo.lang
    const params = parseParam(data)
    return fetch('/wp-json/wolves/v1/schedule?' + params)
        .then(function(response) {
            return response.json()
        })
}

function getNews(data) {
    data.lang = langInfo.lang
    const params = parseParam(data)
    return fetch('/wp-json/wolves/v1/news?' + params)
        .then(function(response) {
            return response.json()
        })
}

export {
    getTeams,
    getTeamsList,
    getScheduleNavList,
    getScheduleList,
    getNews,
}